import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { AdnShipType } from "view/ships/types/ship";

const AdnShipTypeSelect = ({ value, onChange }: Omit<SelectProps<string, false>, "fetchOptions">) => {
	return (
		<Select
			disableSearch
			fetchOptions={Object.keys(AdnShipType)}
			getOptionLabel={opt => `${opt}. ${AdnShipType[opt as keyof typeof AdnShipType]}`}
			multiple={false}
			value={value}
			onChange={onChange} />
	);
};

export default AdnShipTypeSelect;
